/**
 * 글로벌 acquisition 상태 — 모든 페이지에서 공유.
 *
 * 목적:
 *  - 사이드바에 "검색 중" 인디케이터를 상시 노출 (SnapshotDetail 밖에서도 보이게)
 *  - 폴링 중복 방지 (페이지별로 따로 돌리는 대신 1개)
 *
 * 로그인 상태일 때만 폴링. 로그아웃 시 정지.
 */
import { ref } from 'vue'
import { acquisitionApi, type AcquisitionJob } from '@/api/acquisition'
import { isLoggedIn } from '@/api/auth'

const TERMINAL = ['success', 'partial', 'failed', 'cancelled']

export const runningJobs = ref<AcquisitionJob[]>([])
let timer: ReturnType<typeof setInterval> | null = null

function isRunning(j: AcquisitionJob): boolean {
  return !TERMINAL.includes((j.status || '').toLowerCase())
}

async function refreshOnce() {
  if (!isLoggedIn()) {
    runningJobs.value = []
    return
  }
  try {
    const all = await acquisitionApi.listJobs()
    runningJobs.value = all.filter(isRunning)
  } catch { /* transient — keep previous */ }
}

export function startGlobalAcquisitionPoll(intervalMs = 5000) {
  stopGlobalAcquisitionPoll()
  void refreshOnce()
  timer = setInterval(refreshOnce, intervalMs)
}

export function stopGlobalAcquisitionPoll() {
  if (timer) { clearInterval(timer); timer = null }
}

/** 외부에서 즉시 갱신 요청 (예: 방금 job 생성/취소 직후). */
export function pingGlobalAcquisitionPoll() {
  void refreshOnce()
}

/** job 취소 직후 transient state 빠르게 잡기 위한 짧은 간격 3회 연속 갱신. */
export function rapidPollAfterCancel(jobId?: number) {
  // 로컬 선반영: 해당 job을 running 목록에서 즉시 제거 (서버 반영 지연 커버)
  if (jobId != null) {
    runningJobs.value = runningJobs.value.filter((j) => j.id !== jobId)
  }
  let n = 0
  const quick = setInterval(() => {
    void refreshOnce()
    if (++n >= 3) clearInterval(quick)
  }, 1000)
}
